import React from "react";

import { Jsme } from "jsme-react";
import {
  Col,
  Row,
  Container,
  Form,
  Button,
  Table,
  PageItem,
  Modal,
  Spinner,
  Collapse,
  Accordion,
  ButtonGroup,
  Dropdown,
  DropdownButton,
} from "react-bootstrap";
import axios from "axios";
import initRDKit from "../../components/utils/initRDKit";
import { useSearchParams } from "react-router-dom";
import Base from "../../components/BaseTemplate";

function AB3() {
  let [searchParams, setSearchParams] = useSearchParams();
  const [rdKit, setRdKit] = React.useState(null);
  const [smiles, setSmiles] = React.useState(
    searchParams.get("smiles") ? searchParams.get("smiles") : ""
  );
  const [smilestxt, setSmilestxt] = React.useState(
    searchParams.get("smiles") ? searchParams.get("smiles") : ""
  );
  const [libid, setLibid] = React.useState("acse");
  const [tc, setTc] = React.useState(0.35);
  const [id, setID] = React.useState("");
  //if url /ab3/task_id is present, set task to task_id
  const [task, setTask] = React.useState(
    searchParams.get("task") ? searchParams.get("task") : ""
  );

  const [results, setResults] = React.useState([]);
  const [analogs_length, setAnalogsLength] = React.useState(0);
  const [modalElements, setModalElements] = React.useState([]);
  const [bbs, setBb] = React.useState([]);
  const [pairs, setPairs] = React.useState([]);
  const [currentbb, setCurrentbb] = React.useState("");
  const [show, setShow] = React.useState(false);
  const [currentAnalogs, setCurrentAnalogs] = React.useState([]);
  const [spin, setSpin] = React.useState(
    searchParams.get("task") ? true : false
  );
  const [analogsSpinner, setAnalogsSpinner] = React.useState(false);
  const [all_smiles, setAllSmiles] = React.useState([]);

  /*const bb_libs = [
    ["cse", "1-ChemspaceEconomical"],
    ["cs", "2-Chemspace"],
    ["csfm", "3-Chemspace+FastMADE"],
    ["csm", "4-Chemspace+MADE"],
    ["acse", "5-AchiralChemspaceEconomical"],
    ["acs", "6-AchiralChemspace"],
    ["acsfm", "7-AchiralChemspace+FastMADE"],
    ["acsm", "8-AchiralChemspace+MADE"],
  ];*/

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setAnalogsSpinner(true);
    setShow(true);
    setModalElements(<Spinner animation="border" variant="info" />);
    axios.get("/reaction/getanalogs/" + id).then((response) => {
      setAnalogsSpinner(false);
      if (!response.data) {
        setModalElements(
          <tr>
            <td>No analogs found</td>
          </tr>
        );
        return;
      }
      setAllSmiles(response.data.analogs_list.map((item) => item.smiles));
      // setAllSmiles(all_smiles.concat(response.data.analogs_list.map((item) => item.smiles)));
      setModalElements(
  response.data.analogs_list.map((item, index) => (
    <tr key={index}>
      <td style={{ position: "relative", width: "240px", height: "240px" }}>
        <img
          height="240"
          width="240"
          src={
            "https://sw.docking.org/depict/svg?smi=" +
            encodeURIComponent(item.smiles)
          }
          alt="analog"
          style={{ display: "block" }}
        />
        <Button
          variant="outline-secondary"
          size="sm"
          style={{
            position: "absolute",
            top: "5px",
            right: "5px",
            fontSize: "12px",
            padding: "2px 6px",
            zIndex: 2,
          }}
          onClick={() =>
            window.open(
              `https://commons.docking.org/ab3?smiles=${item.smiles}`,
              "_blank"
            )
          }
        >
          Open
        </Button>
      </td>
      <td style={{ verticalAlign: "middle" }}>{item.smiles}</td>
      <td style={{ verticalAlign: "middle" }}>
        <a
          href={`https://cartblanche22.docking.org/substance/${item.orig}`}
          target="_blank"
        >
          {item.orig}
        </a>
      </td>
    </tr>
  ))
);


      setCurrentAnalogs(response.data.analogs_list);
    });
  };

  React.useEffect(() => {
    if (all_smiles.length > 0) {
      for (var i = 0; i < all_smiles.length; i++) {
        var canvas = document.getElementById(all_smiles[i]);
        if (canvas === null) {
          return;
        }
        rdKit.get_mol(all_smiles[i]).draw_to_canvas(canvas, 250, 250);
      }
    }
  }, [all_smiles]);

  function downloadTXT() {
    let smilesList = ["Building Block" + "\t" + "Reaction" + "\n"];
    const element = document.createElement("a");
    bbs.map((item) =>
      smilesList.push(item.smiles + "\t" + item.Reaction_name + "\n")
    );
    const file = new Blob(smilesList, { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "BBsmiles.txt";
    document.body.appendChild(element);
    element.click();
  }

  React.useEffect(() => {
    initRDKit().then((rdKit) => {
      setRdKit(rdKit);
    });
  }, []);

  
  function downloadTXT2() {
  if (!currentAnalogs || currentAnalogs.length === 0) {
    alert("No analogs found for download.");
    return;
  }

  let analogsList = [];
  currentAnalogs.forEach((analog) => {
    analogsList.push(`${analog.smiles} ${analog.orig}\n`);
  });
  const fileContent = analogsList.join("\n"); // no trailing newline
  const file = new Blob([fileContent], { type: "text/plain" });
  const element = document.createElement("a"); // <-- FIXED HERE
  element.href = URL.createObjectURL(file);
  const safeBB = currentbb.replace(/[^a-zA-Z0-9-_]/g, "_");
  element.download = `analogs${safeBB}.smi`;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element); // clean up
  }

  function showspinner() {
    if (spin === true) {
      return <Spinner animation="grow" variant="success" />;
    } else {
      return;
    }
  }
  function showspinner2() {
    if (spin === true) {
      return <Spinner animation="border" variant="success" />;
    } else {
      return;
    }
  }

  function submitTask() {
    // const data = { smiles: smilestxt, tc: tc, id: id, libid: libid };
    var bodyFormData = new FormData();

    bodyFormData.append("smiles", smilestxt);

    bodyFormData.append("tc", tc);
    bodyFormData.append("id", id);
    bodyFormData.append("libid", libid);

    axios({
      url: "/reaction/disconnect",
      method: "post",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    }).then((response) => {
      setBb([]);
      setPairs([]);
      window.history.pushState({}, "", "/ab3?task=" + response.data.task_id);
      if (response.data.task_id !== task) {
        setTask(response.data.task_id);
        setSpin(true);
      }
    });
  }

  function submitTest() {
    setTc(0.25);
    // setSmiles("Cc3ccc(NC(=O)c2ccc(CN1CCN(C)CC1)cc2)cc3Nc5nccc(c4cccnc4)n5");
    writesmiles(
      "Cc3ccc(NC(=O)c2ccc(CN1CCN(C)CC1)cc2)cc3Nc5nccc(c4cccnc4)n5",
      false,
      true
    );
  }

  React.useEffect(() => {
    if (task === "") {
      return;
    }

    function getProgress() {
      return axios.get("/results/" + task).then((result) => {
        console.log(result.data);
        if (result.data.ready) {
          setResults(result.data.arthor_results);

          setSpin(false);
          // clearInterval(progressRequest);
          setBb([]);
          console.log(result.data);
          var res = result.data.results[0].results;
          setBb(result.data.results[0].results);

          let pairs = {};
          let smi = [];
          for (var i = 0; i < res.length; i++) {
            var item = res[i];
            smi.push(item.smiles);
            if (item.pair_id in pairs) {
              pairs[item.pair_id].push(item);
            } else {
              pairs[item.pair_id] = [item];
            }
          }
          // setAllSmiles(all_smiles.concat(smi));
          setPairs([]);
          setPairs(pairs);
        } else {
          setSpin(true);
          setTimeout(() => {
            getProgress();
          }, 500);
        }
      });
    }

    getProgress();
  }, [task, spin]);

 
function showBbs() {
  let bbsTracker = {};
  let reactions = [];

  Object.keys(pairs).forEach((pair_id) => {
    const firstItem = pairs[pair_id][0];
    const name = firstItem["Reaction_name"];
    const id = firstItem["Reaction_id"];

    if (!bbsTracker[pair_id]) {
      reactions.push({
        name,
        id,
        building_blocks: pairs[pair_id],
      });
      bbsTracker[pair_id] = true;
    }
  });
  reactions.sort((a, b) => {
    const extractNumber = (id) => parseFloat(id.split("-").pop());
    return extractNumber(a.id) - extractNumber(b.id);
  });

  return reactions.map((reaction, index) => (
    <React.Fragment key={index}>
      <tr>
        <th colSpan={reaction.building_blocks.length}>
          <div>
            <b>Reaction:</b> {reaction.name} <b>ID:</b> {reaction.id}
          </div>
        </th>
      </tr>
      <tr>
        {reaction.building_blocks.map((bb, bbIndex) => (
          <td
            key={bbIndex}
            style={{
              textAlign: "center",
              transition: "background-color 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#edf2dc";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "";
            }}
          >
            <div
              style={{
                border: "1px solid #ccc",
                padding: "5px",
                borderRadius: "8px",
                cursor: "pointer",
                position: "relative",
              }}
              title={bb.smiles}
              draggable
              onClick={() => {
                handleShow(bb.smiles);
                setCurrentbb(bb.smiles);
              }}
              onDragStart={(e) => {
                e.dataTransfer.setData("text/plain", bb.smiles);
              }}
            >
              <img
                height="150"
                width="150"
                src={`https://sw.docking.org/depict/svg?smi=${encodeURIComponent(bb.smiles)}`}
                alt="molecule"
                style={{ pointerEvents: "none" }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: "5px",
                  left: 0,
                  right: 0,
                  fontSize: "12px",
                  color: "#007bff",
                }}
              >
                Click to view analogs
              </div>
            </div>
          </td>
        ))}
      </tr>
    </React.Fragment>
  ));
}

  function writesmiles(smiles, fromJSME = false, fromText = false) {
    if (fromJSME) {
      setSmilestxt(smiles);
    } else if (fromText) {
      setSmilestxt(smiles);
      setSmiles(smiles);
    }
  }

  return (
    <Base>
      <Row>
        <Col className="pt-4" lg={4} md={6} sm={12}>
          <Form onSubmit={submitTask}>
            <Form.Group>
              <Jsme
                src="/jsme/jsme.nocache.js"
                height="20rem"
                width="auto"
                options={"noautoez,newlook,nocanonize,multipart,zoom"}
                smiles={
                  rdKit && rdKit.get_mol(smiles)
                    ? rdKit.get_mol(smiles).get_smiles()
                    : smiles
                }
                onChange={(smiles) => writesmiles(smiles, true, false)}
              />
            </Form.Group>

            <Form.Group minwidth="400px" maxwidth="400px">
              <Form.Label>
                <b>SMILES</b>{" "}
              </Form.Label>
              <Form.Control
                type="text"
                value={smilestxt}
                onChange={(e) => writesmiles(e.target.value, false, true)}
              />
            </Form.Group>
            <Row>
              <Col lg={6} md={6} sm={6}>
                <Form.Group>
                  <Form.Label>
                    <b>TC</b>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    defaultValue="0.35"
                    min="0"
                    max="1"
                    step="0.01"
                    value={tc}
                    onChange={(e) => setTc(e.target.value)}
                  />
                  <Form.Range
                    type="range"
                    defaultValue="0.35"
                    value={tc}
                    min="0"
                    max="1"
                    step="0.01"
                    onChange={(e) => setTc(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col lg={6} md={6} sm={6}>
                <Form.Group>
                  <Form.Label>
                    <b>RxnID</b>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={id}
                    onChange={(e) => setID(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
          <br></br>
          <Button variant="success" onClick={submitTask}>
            Submit
          </Button>{" "}
          <ButtonGroup>
            <Button variant="secondary" disabled>
              Library
            </Button>
            <DropdownButton variant="outline-success"
              as={ButtonGroup}
              title={libid}
              id="bg-nested-dropdown"
            >
              <Dropdown.Item onClick={() => setLibid("cse")}>
                <b>1-ChemspaceEconomical</b>
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setLibid("cs")}>
                <b>2-Chemspace</b>
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setLibid("csfm")}>
                <b>3-Chemspace+FastMADE</b>
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setLibid("csm")}>
                <b>4-Chemspace+MADE</b>
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setLibid("acse")}>
                <b>5-AchiralChemspaceEconomical</b>
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setLibid("acs")}>
                <b>6-AchiralChemspace</b>
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setLibid("acsfm")}>
                <b>7-AchiralChemspace+FastMADE</b>
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setLibid("acsm")}>
                <b>8-AchiralChemspace+MADE</b>
              </Dropdown.Item>

            </DropdownButton>
          </ButtonGroup>
          &nbsp;
          <Button variant="outline-success" onClick={submitTest}>
            Test Gleevec
          </Button>
          {/* <Button variant="outline-info" id="download" onClick={downloadTXT}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              margin="3"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-cloud-download-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.5a.5.5 0 0 1 1 0V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0zm-.354 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V11h-1v3.293l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"
              />
            </svg>
          </Button> */}
        </Col>

        <Col lg={8} md={6} sm={12} className="pt-4">
          <div className="overflow-auto" style={{ maxHeight: "650px" }}>
            <Table table-light striped bordered size="sm">
              <tbody>
                {showspinner2()}
                {showspinner()}
                {showspinner2()}
                {showBbs()}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>

      <Modal
        show={show}
        size="lg"
        onHide={handleClose}
        animation={false}
        width="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {currentbb} Building Block Analogs: {modalElements.length}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="overflow-auto" style={{ maxHeight: "600px" }}>
            <Table striped bordered hover>
              <thead>
                <th>Molecule</th>
                <th>SMILES</th>
                <th>Purchasability</th>
              </thead>
              <tbody>{modalElements}</tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="success" onClick={downloadTXT2}>
            Download
          </Button>
        </Modal.Footer>
      </Modal>
    </Base>
  );
}

export default AB3;
